import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('crop-planning'));
const MFPlugin = React.lazy(() => import('cropPlanning/CropPlanning'));

export const CropPlanningPluginContainer: React.FC = () => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.cropPlanning.module-federation'];

  const CropPlanningPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <CropPlanningPlugin />;
};
